export const PUSH_NOTIFICATION_TYPES = {
    VISITA_ASIGNADA: 'visita_asignada',
    VISITA_REPROGRAMADA: 'visita_reprogramada',
    VISITA_CANCELADA: 'visita_cancelada',
    VISITA_INICIADA: 'visita_iniciada',
    VISITA_FINALIZADA: 'visita_finalizada',
    ALERTA_SISTEMA: 'alerta_sistema',
    RECORDATORIO_VISITA: 'recordatorio_visita',
    MENSAJE_ADMINISTRATIVO: 'mensaje_administrativo',
};

/**
 * Procesa la acción cuando el usuario toca una notificación push.
 * Redirige a la pantalla correspondiente según el tipo y payload.
 */
export function handlePushNotificationNavigation(action, navigate) {
    if (!action || !navigate) return;

    const data =
        action.notification?.data ||
        action.notification?.additionalData ||
        action.notification?.request?.content?.data ||
        {};

    const type = data.type || data.notification_type;
    const entityId = data.entityId || data.visitaId || data.id;

    console.log('[NotificationRouter] Action performed with type:', type, 'data:', data);

    switch (type) {
        case PUSH_NOTIFICATION_TYPES.VISITA_ASIGNADA:
        case PUSH_NOTIFICATION_TYPES.VISITA_REPROGRAMADA:
        case 'visita':
            if (entityId) {
                navigate(`/visitas/${entityId}/editar`);
            } else {
                navigate('/visitas');
            }
            break;

        case PUSH_NOTIFICATION_TYPES.VISITA_CANCELADA:
        case PUSH_NOTIFICATION_TYPES.RECORDATORIO_VISITA:
            navigate('/visitas');
            break;

        case 'solicitud':
        case 'solicitud_visita':
            navigate('/solicitudes-visita');
            break;

        case 'observacion':
        case 'observacion_correctiva':
            navigate('/observaciones-correctivas');
            break;

        case 'informe':
            navigate('/informes');
            break;

        default:
            navigate('/dashboard');
            break;
    }
}
